import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/login/Login';
import ForgotPassword from './components/forgotPassword/ForgotPassword';
import ResetPassword from './components/resetPassword/ResetPassword';
import Dashboard from './components/dashboard/Dashboard';
import CalendarPage from './components/calendarPage/CalendarPage';
import FinancialDashboard from "./components/financialDashboard/FinancialDashboard";
import EmployeeManagement from "./components/employee/EmployeeManagement";
import HistoryPage from "./components/history/HistoryPage";

// Import other components you need

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                    <Route path="/reset-password" element={<ResetPassword/>}/>

                    {/* Protected routes */}
                    <Route element={<ProtectedRoute/>}>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                        <Route path="/calendar" element={<CalendarPage/>}/>
                        <Route path="/budgeting" element={<FinancialDashboard/>}/>
                        <Route path="/employees" element={<EmployeeManagement/>}/>
                        <Route path="/history" element={<HistoryPage/>}/>
                        {/* Add more protected routes here */}
                    </Route>

                    {/* Redirect root to dashboard or login depending on auth status */}
                    <Route path="/" element={<Navigate to="/dashboard" replace/>}/>

                    {/* Fallback for unknown routes */}
                    <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;